import CustomLink from 'components/Globals/Base/Link';
import styled from 'styled-components';
import { breakpoint, color, font } from 'styles/globals';
import { type Theme, getBodyStyle, getColor } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Header = styled(Heading)<{ theme: Theme }>`
  background-color: ${getColor('surfaceSecondary')};
  padding: 16px;

  @media (${breakpoint.mdMin}) {
    padding: 16px 24px;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;

  @media (${breakpoint.mdMin}) {
    padding: 24px;
  }
`;

export const ListItemWrapper = styled.li<{ theme: Theme }>`
  padding: 8px 0;
  display: grid;
  grid-template-columns: 20px auto;
  column-gap: 8px;
  &:not(:last-child) {
    border-bottom: 1px solid ${getColor('borderPrimary')};
  }
  & > *:nth-child(1) {
    grid-row: span 3;
  }
`;

export const Link = styled(CustomLink)`
  & > * {
    font-family: ${font.graphikCond};
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;

    @media (${breakpoint.mdMin}) {
      font-size: 20px;
    }
  }
`;

export const Current = styled.span<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};
  text-transform: uppercase;
  color: ${color.recommendsGreen};
`;

export const Position = styled.span<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'small', mdMin: 'default' }, 'semiBold')};
  color: ${getColor('textSecondary')};
`;

export const BulletIcon = styled.span<{ $isCurrent: boolean }>`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ $isCurrent }) =>
    $isCurrent ? `${color.recommendsGreen}26` : `${getColor('neutralLightGray2')}`};
  ${({ $isCurrent }) =>
    $isCurrent &&
    `
      &:after {
        content: "";
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: ${color.recommendsGreen};
        border-radius: 50%;
        top: 4px;
        left: 4px;
      }
  `}
`;

export const ListWrapper = styled.div<{ $color: string; theme: Theme }>`
  border: 1px solid ${getColor('borderPrimary')};;

  ${Current} {
    color: ${(props) => props.$color};
  }

  ${BulletIcon} {
    &:after {
      background-color: ${(props) => props.$color};
    }
  }
`;
